







































































































import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size, Spacing } from '@front-app/components/constants';
import TrForm from '@front-app/components/form/Form.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import CategoriesInput from '@front-app/components/inputs/CategoriesInput.vue';
import { STATUS } from '@front-app/constants/state';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { EventBus, EventBusEvent } from '@front-app/services/EventBus';
import { CreateLinkRequest, addLink } from '@front-app/services/GroupsApi/GroupLinkApi';
import { verifyUrl } from '@front-app/services/UrlApi/UrlApi';
import { UrlInfo } from '@front-app/services/UrlApi/UrlInfoModel';

export default defineComponent({
	components: {
		CategoriesInput,
		CtaButton,
		ErrorCard,
		FormError,
		FormInput,
		FormLabel,
		FormSection,
		LoaderState,
		TrForm,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		messageId: {
			type: String,
			default: '',
		},
		categories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		defaultCategories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		canAddNewCategories: Boolean,
	},
	setup(props, ctx) {
		const link = ref(new UrlInfo());
		const linkUrl = ref('');

		// Validation
		const validation = v({
			url: {
				value: linkUrl,
				rules: [required()],
			},
			name: {
				value: computed(() => link.value.pageTitle),
				rules: [required()],
			},
		});

		const { focusFirstInvalid } = useFocusFirstInvalidField({
			containerSelector: '#share-link-form',
			scrollConfig: { block: 'center' },
		});
		// END Validation

		// Link URL
		const updateUrl = async (input: string) => {
			if (link.value.requestedUrl !== input.trim()) {
				const href = input.trim();
				link.value.requestedUrl = href;

				const result = await verifyUrl(href);
				if (!result.isSuccess) {
					link.value.status = STATUS.ERROR;
				} else {
					link.value = result;
					link.value.status = STATUS.SUCCESS;
				}
			}
		};
		// Link URL

		// Categories
		const selectedCategories = ref([...props.defaultCategories]);
		const selectedNewCategories = ref([]);
		const removeCategory = (cat: string) => {
			selectedCategories.value = selectedCategories.value.filter((current) => current !== cat);
		};
		const removeNewCategory = (cat: string) => {
			selectedNewCategories.value = selectedNewCategories.value.filter((current) => current !== cat);
		};
		// END Categories

		// Submission
		const {
			track,
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus();

		const shareLink = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			const category = ([] as string[])
				.concat(selectedCategories.value)
				.concat(selectedNewCategories.value);

			const payload: CreateLinkRequest = {
				name: link.value.pageTitle,
				description: link.value.pageDescription,
				url: link.value.requestedUrl,
				category,
				messageId: props.messageId || undefined, // Empty string as a messageId causes API failures
			};

			const createdLink = await track(addLink(props.groupId, payload));

			if (isSuccess.value) {
				ctx.emit('link-shared', createdLink.id);
				EventBus.emit(EventBusEvent.LINK_SHARED);
			}
		};
		// END Submission

		return {
			link,
			// Link URL
			linkUrl,
			updateUrl,
			// Categories
			selectedCategories,
			selectedNewCategories,
			removeCategory,
			removeNewCategory,
			// Validation
			validation,
			// Submission
			shareLink,
			isLoading,
			isError,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
			STATUS,
		};
	},
});
